// add this directive to an iFrame element and pass a name of the source, and this will change the height based on the
// events passed from the iframe source. the name of the source, and type of the message are checked before making a
// change to the element width.
// expects an object like to have been sent through the window.postMessage() interface :

// {
//     type: 'resize',
//     source: 'some-iframe-content',
//     value: {
//         height: 200
//     }
// }

// <iframe src="some-iframe.html" iframe-resizer="some-iframe-content"></iframe>

import { Directive, OnDestroy, HostListener, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[iframe-resizer]'
})

export class IFrameResizerDirective implements OnDestroy {
    @Input('iframe-resizer') sourceName: string;

    constructor(private el: ElementRef) { }


    @HostListener('window:message', ['$event'])

    onMessage(event: any) {
        if ('undefined' !== typeof event.data &&
            'undefined' !== typeof event.data.type &&
             event.data.type === 'resize' &&
            'undefined' !== typeof event.data.source &&
             event.data.source === this.sourceName) {
                this.resizeIframe(event.data);

        }
    }

    resizeIframe(data) {
       if ('undefined' !== typeof data.value && 'undefined' !== typeof data.value.height) {
           if (this.el.nativeElement.clientHeight !== Number(data.value.height)) {
               this.el.nativeElement.style.height = data.value.height + 'px';
           }
       }
    }

    ngOnDestroy() {
        // TODO: destroy @HostListener watcher?
    }


}